/* LU AI virtual try-on (MVP). Backend URL, pill text and position: Theme settings > LU – Optimizări > Probă virtuală
   (rendered by snippets/lu-tryon.liquid as data-* attributes).
   Theme editor (data-design-mode): the pill opens the dialog with a note, the photo pickers are disabled and the
   backend is NEVER called (no spend). Sections are re-initialised on shopify:section:load and cleaned up on
   shopify:section:unload (the dialog lives in <body>, the pill in the gallery).
   AUTOHIDE1: the pill is only rendered when <backend>/status-public does not say available:false (fail-open).
   AB1 (A/B test without the button for group B, cart attribute _lu_ab, exposure ping <backend>/ab): see "AB1" below. */
(function () {
  'use strict';

  var MAX_SIDE = 1024;
  var CLIENT_TIMEOUT_MS = 80000;

  // Guide per category: 1 "Așa da" + 2 "Așa nu" real photos. Image keys: data.examples["<cat>_da" | "<cat>_nu_1" | "<cat>_nu_2"]
  // (snippets/lu-tryon.liquid builds that map from assets/lu-tryon-ex-<cat>-*.jpg; every category has all three).
  var GUIDES = {
    ear: {
      label: 'cercei',
      lead: 'Fă o poză de aproape cu urechea, ca în exemplu. Cu cât se vede mai clar lobul urechii, cu atât preview-ul e mai reușit.',
      tips: ['Dă părul după ureche, să se vadă tot lobul', 'Lumină naturală, clară (lângă o fereastră)', 'Prim-plan, din profil, telefonul la 20–30 cm'],
      yes: 'Urechea complet vizibilă, părul prins, lumină bună',
      nos: ['Prea întunecat', 'Urechea acoperită']
    },
    neck: {
      label: 'coliere',
      lead: 'Fă o poză cu gâtul și claviculele, ca în exemplu.',
      tips: ['Gâtul și claviculele la vedere', 'Fără eșarfă, guler înalt sau alt colier', 'Lumină clară, din față'],
      yes: 'Gâtul și claviculele la vedere, părul prins',
      nos: ['Gât acoperit (eșarfă, guler)', 'Prea întunecat']
    },
    hand: {
      label: 'inele',
      lead: 'Fă o poză cu mâna întinsă, cu dosul palmei spre cameră, ca în exemplu.',
      tips: ['Mâna întinsă, dosul palmei spre cameră', 'Degetele ușor depărtate, fără alte inele', 'Lumină clară, fundal simplu'],
      yes: 'Dosul palmei spre cameră, de aproape',
      nos: ['Poză mișcată', 'Mâna prea departe']
    },
    wrist: {
      label: 'brățări',
      lead: 'Fă o poză cu încheietura la vedere, ca în exemplu.',
      tips: ['Încheietura la vedere, mâneca trasă înapoi', 'Dosul încheieturii spre cameră', 'Fără ceas sau alte brățări, lumină clară'],
      yes: 'Încheietura la vedere, de aproape',
      nos: ['Mâneca acoperă încheietura', 'Poză mișcată']
    },
    ankle: {
      label: 'brățări de picior',
      lead: 'Fă o poză cu glezna din profil, de aproape, ca în exemplu.',
      tips: ['Glezna goală, fără șosetă sau pantalon peste ea', 'Din profil, piciorul pe podea, telefonul la 30–40 cm', 'Lumină clară, fundal simplu, fără alte brățări'],
      yes: 'Glezna din profil, la vedere, de aproape',
      nos: ['Gleznă acoperită (șosetă, pantalon)', 'Poză de prea departe']
    }
  };

  var ERRORS = {
    rate_limited: 'Ai atins limita de probe virtuale pe azi. Revino mâine!',
    budget_exhausted: 'Proba virtuală nu mai este disponibilă momentan. Revino în curând!',
    busy: 'Se generează deja un preview. Așteaptă să se termine, apoi încearcă din nou.',
    server_busy: 'Sunt multe cereri acum. Te rugăm să reîncerci peste un minut.',
    timeout: 'Generarea a durat prea mult. Te rugăm să reîncerci.',
    photo_too_big: 'Fotografia este prea mare (maxim 8 MB). Încearcă altă poză.',
    bad_photo: 'Fișierul ales nu este o imagine validă. Încearcă o fotografie JPG sau PNG.',
    no_image: 'Nu am reușit să generăm preview-ul pentru această fotografie. Încearcă o poză mai clară, conform ghidului.',
    network: 'Nu ne-am putut conecta la serviciul de probă virtuală. Verifică internetul și reîncearcă.',
    generic: 'A apărut o eroare. Te rugăm să reîncerci în câteva momente.'
  };

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  var CAT_RES = [
    ['ear', /\b(cercei|cercel|earrings?|huggies?)\b/],
    ['neck', /\b(colier|coliere|lantisor|lantisoare|pandantiv|pandantive|necklaces?|pendants?|choker)\b/],
    ['hand', /\b(inel|inele|rings?)\b/],
    ['wrist', /\b(bratara|bratari|bracelets?|bangles?)\b/]
  ];
  // The keyword that appears FIRST wins ("Inel Heart Pendant" -> ring, not necklace).
  function matchCategory(s) {
    s = norm(s);
    if (!s) return null;
    var best = null, bestAt = Infinity;
    CAT_RES.forEach(function (c) {
      var m = c[1].exec(s);
      if (m && m.index < bestAt) { bestAt = m.index; best = c[0]; }
    });
    return best;
  }

  function detectCategory(p) {
    var tags = (p.tags || []).map(norm);
    for (var i = 0; i < tags.length; i++) {
      var m = tags[i].match(/^tryon:(off|ear|neck|hand|wrist|ankle)$/);
      if (m) return m[1] === 'off' ? null : m[1];
    }
    // Ankle bracelets (tag "bratarapicior", "de picior" in the title, anklet / gleznă anywhere) -> ankle. Checked
    // before the keyword match, otherwise "Brățara de picior" would be a wrist bracelet. (Until this batch: hidden.)
    var all = norm([p.type, tags.join(' '), p.title].join(' '));
    if (/picior|\bankles?\b|\banklets?\b|glezn/.test(all)) return 'ankle';
    // Title first (most reliable on lu.ro: some product types are wrong, e.g. "Colier Bezel" typed Earrings), then tags, then type.
    return matchCategory(p.title) || matchCategory(tags.join(' ')) || matchCategory(p.type);
  }

  // ---- TRACK1: hidden order tagging. After a successful preview the cart gets the hidden attributes
  // _lu_tryon=da, _lu_tryon_products=<handles, last 10>, _lu_tryon_last=<ISO time> (shown on the order in Shopify
  // admin under "Additional details", hidden from the customer: "_" prefix). A cart line added from the try-on
  // dialog also gets the hidden line property _lu_tryon=da. No photo / personal data, only handles + a timestamp.
  // Everything here is fire-and-forget: errors are swallowed and never reach the preview or add-to-cart.
  var TRACK_KEY = 'lu_tryon_used';
  var TRACK_TTL_MS = 30 * 24 * 3600 * 1000;
  function trackRead() {
    try {
      var r = JSON.parse(window.localStorage.getItem(TRACK_KEY) || 'null');
      if (!r || !r.t || !Array.isArray(r.h)) return null;
      if (Date.now() - Date.parse(r.t) > TRACK_TTL_MS) { window.localStorage.removeItem(TRACK_KEY); return null; }
      return r;
    } catch (e) { return null; }
  }
  function trackAttrs(r) {
    var list = r.h.slice(-10), s = list.join(',');
    while (s.length > 250 && list.length > 1) { list.shift(); s = list.join(','); }
    return { _lu_tryon: 'da', _lu_tryon_products: s.slice(0, 250), _lu_tryon_last: r.t };
  }
  function cartRoot() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  // ---- AB1: A/B test "probă virtuală" (owner approved 2026-10-08). Settings: Theme settings > LU – Optimizări >
  // "Test A/B probă virtuală" (data-ab) and "Procent fără buton (B)" (data-ab-b-pct, 0-50), rendered by
  // snippets/lu-tryon.liquid. Group B never gets the pill or the dialog and never calls the backend /tryon.
  // Sticky group: localStorage "lu_ab" + first-party cookie "lu_ab" (180 days). If neither can be written the visitor
  // is A, not persisted and NOT counted (no _lu_ab attribute, no ping). Theme editor = A, not counted. Test off = A,
  // not counted. Counted visitors get the hidden cart attribute _lu_ab=A|B and one anonymous exposure ping per day
  // (POST <backend>/ab {g, h, v}, v = random id in lu_ab_vid) on an eligible product page. No personal data.
  var AB_DAYS = 180;
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); return window.localStorage.getItem(k) === v; } catch (e) { return false; } }
  function ckGet(k) {
    try { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; } catch (e) { return null; }
  }
  function ckSet(k, v) {
    try {
      document.cookie = k + '=' + encodeURIComponent(v) + '; max-age=' + (AB_DAYS * 86400) + '; path=/; SameSite=Lax' +
        (location.protocol === 'https:' ? '; Secure' : '');
      return ckGet(k) === v;
    } catch (e) { return false; }
  }
  // localStorage first, the cookie as fallback; a value found in one is copied to the other when it is missing there.
  function stGet(k, ok) {
    var a = lsGet(k), b = ckGet(k);
    var v = ok(a) ? a : (ok(b) ? b : null);
    if (v !== null) { if (a !== v) lsSet(k, v); if (b !== v) ckSet(k, v); }
    return v;
  }
  function stSet(k, v) { var a = lsSet(k, v), b = ckSet(k, v); return a || b; }
  function randU32() {
    try { var x = new Uint32Array(1); window.crypto.getRandomValues(x); return x[0]; } catch (e) { return Math.floor(Math.random() * 4294967296); }
  }
  var isGroup = function (v) { return v === 'A' || v === 'B'; };
  var isVid = function (v) { return typeof v === 'string' && /^[A-Za-z0-9_-]{8,64}$/.test(v); };
  // {g, on (test enabled), counted}. Computed once per page from the first [data-lu-tryon] wrapper.
  function abState() {
    if (window.__luAb) return window.__luAb;
    var root = document.querySelector('[data-lu-tryon]');
    if (!root) return { g: 'A', on: false, counted: false };
    var st = { g: 'A', on: root.getAttribute('data-ab') === '1', counted: false };
    try {
      if (st.on && !root.hasAttribute('data-design-mode')) {
        var g = stGet('lu_ab', isGroup);
        if (g) st.counted = true;
        else {
          var pct = parseInt(root.getAttribute('data-ab-b-pct'), 10);
          pct = isNaN(pct) ? 20 : Math.max(0, Math.min(50, pct));
          g = randU32() / 4294967296 < pct / 100 ? 'B' : 'A';
          st.counted = stSet('lu_ab', g);
          if (!st.counted) g = 'A'; // nothing persisted: show the button, do not count this visitor
        }
        st.g = g;
      }
    } catch (e) { st = { g: 'A', on: st.on, counted: false }; }
    window.__luAb = st;
    return st;
  }
  function abVisitorId() {
    var v = stGet('lu_ab_vid', isVid);
    if (v) return v;
    var s = '';
    for (var i = 0; i < 4; i++) s += ('0000000' + randU32().toString(16)).slice(-8);
    return stSet('lu_ab_vid', s) ? s : null;
  }
  // One exposure ping per visitor per (local) day. text/plain body: a CORS "simple" request, no preflight.
  function abPing(backend, handle) {
    try {
      var ab = abState();
      if (!ab.on || !ab.counted || !/^https:\/\//.test(backend) || !handle) return;
      var d = new Date();
      var day = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      if (stGet('lu_ab_ping', function (x) { return x === day; })) return;
      var v = abVisitorId();
      if (!v || !stSet('lu_ab_ping', day)) return; // cannot dedupe -> do not send
      var url = backend + '/ab', body = JSON.stringify({ g: ab.g, h: String(handle), v: v });
      var sent = false;
      try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(url, body)); } catch (e) { sent = false; }
      if (!sent) {
        fetch(url, { method: 'POST', body: body, keepalive: true, credentials: 'omit', mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
      }
    } catch (e) {}
  }

  // Hidden cart attributes this visitor should carry: the TRACK1 try-on ones and the AB1 group.
  function wantAttrs() {
    var w = {}, r = trackRead();
    if (r) { var t = trackAttrs(r); for (var k in t) w[k] = t[k]; }
    var ab = abState();
    if (ab.on && ab.counted) w._lu_ab = ab.g;
    return w;
  }
  function cartPushAttrs(w) {
    try {
      var n = 0; for (var k in w) n++;
      if (!n) return Promise.resolve();
      // cart/update.js merges: only the keys sent change, other attributes stay.
      return fetch(cartRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: w })
      }).then(function () {}, function () {});
    } catch (e) { return Promise.resolve(); }
  }
  function trackPreview(handle) {
    try {
      var r = trackRead() || { h: [] };
      handle = String(handle || '').replace(/,/g, '');
      if (handle) {
        r.h = r.h.filter(function (x) { return x !== handle; });
        r.h.push(handle);
        r.h = r.h.slice(-10);
      }
      r.t = new Date().toISOString();
      try { window.localStorage.setItem(TRACK_KEY, JSON.stringify(r)); } catch (e) {}
      var w = trackAttrs(r), ab = abState();
      if (ab.on && ab.counted) w._lu_ab = ab.g;
      cartPushAttrs(w);
    } catch (e) {}
  }
  // Re-apply on load and after every add to cart: when the cart has items but lacks (or has stale) hidden attributes
  // (e.g. the cart did not exist yet), send only the keys that differ.
  function trackSync() {
    try {
      var want = wantAttrs(), any = false;
      for (var k0 in want) { any = true; break; }
      if (!any) return;
      fetch(cartRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (c) {
          if (!c || !(c.item_count > 0)) return;
          var a = c.attributes || {}, diff = {}, n = 0;
          for (var k in want) if (a[k] !== want[k]) { diff[k] = want[k]; n++; }
          // TRACK1 keys always travel together (unchanged behaviour)
          if (want._lu_tryon && (diff._lu_tryon || diff._lu_tryon_products || diff._lu_tryon_last)) {
            diff._lu_tryon = want._lu_tryon; diff._lu_tryon_products = want._lu_tryon_products; diff._lu_tryon_last = want._lu_tryon_last;
          }
          if (n) cartPushAttrs(diff);
        })
        .catch(function () {});
    } catch (e) {}
  }
  if (!window.__luTryonTrack) {
    window.__luTryonTrack = true;
    document.addEventListener('cart:item-added', function () { setTimeout(trackSync, 300); });
    if (document.readyState === 'complete') setTimeout(trackSync, 1500);
    else window.addEventListener('load', function () { setTimeout(trackSync, 1500); });
  }

  function abs(u) {
    if (!u) return null;
    return u.indexOf('//') === 0 ? 'https:' + u : u;
  }

  // Resize on the client to max 1024 px JPEG (EXIF orientation is applied by the browser).
  function resizePhoto(file) {
    return new Promise(function (resolve) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          var scale = Math.min(1, MAX_SIDE / Math.max(w, h));
          var cw = Math.max(1, Math.round(w * scale)), ch = Math.max(1, Math.round(h * scale));
          var c = document.createElement('canvas');
          c.width = cw; c.height = ch;
          c.getContext('2d').drawImage(img, 0, 0, cw, ch);
          c.toBlob(function (b) {
            URL.revokeObjectURL(url);
            resolve(b || file);
          }, 'image/jpeg', 0.9);
        } catch (e) {
          URL.revokeObjectURL(url);
          resolve(file);
        }
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  // ---- AUTOHIDE1 (owner approved 2026-10-13): while Google refuses the backend's requests (spend cap / quota / billing)
  // GET <backend>/status-public answers {available:false} and the pill is NOT rendered. Fail-open: a timeout (2 s), a
  // network error or an unexpected answer renders the pill as before. The answer is cached 60 s in sessionStorage
  // "lu_tryon_status" ({t, a, b}); one request per page. Theme editor: never asked (pill always shown).
  var STATUS_KEY = 'lu_tryon_status', STATUS_TTL = 60000, STATUS_TIMEOUT = 2000, statusWait = null;
  function upstreamAvailable(backend, cb) {
    var done = false;
    function finish(a) { if (done) return; done = true; try { cb(a); } catch (e) {} }
    try {
      var c = JSON.parse(window.sessionStorage.getItem(STATUS_KEY) || 'null');
      var age = c && Date.now() - c.t;
      if (c && c.b === backend && typeof c.a === 'boolean' && age >= 0 && age < STATUS_TTL) { finish(c.a); return; }
    } catch (e) {}
    try {
      if (!statusWait) {
        statusWait = new Promise(function (resolve) {
          var settled = false, ctl = null, timer;
          function res(a) { if (!settled) { settled = true; clearTimeout(timer); resolve(a); } }
          timer = setTimeout(function () { res(null); if (ctl) { try { ctl.abort(); } catch (e) {} } }, STATUS_TIMEOUT);
          try {
            ctl = typeof AbortController === 'function' ? new AbortController() : null;
            fetch(backend + '/status-public', { credentials: 'omit', signal: ctl ? ctl.signal : undefined })
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (j) {
                var a = j && typeof j.available === 'boolean' ? j.available : null;
                if (a !== null) { try { window.sessionStorage.setItem(STATUS_KEY, JSON.stringify({ t: Date.now(), a: a, b: backend })); } catch (e) {} }
                res(a);
              }, function () { res(null); });
          } catch (e) { res(null); }
        });
      }
      statusWait.then(function (a) { finish(a !== false); }, function () { finish(true); });
    } catch (e) { finish(true); }
  }

  function init(root) {
    if (root.__luTryon) return;
    root.__luTryon = true;
    var data;
    try { data = JSON.parse(root.querySelector('[data-lu-tryon-product]').textContent); } catch (e) { return; }
    var cat = detectCategory(data);
    if (!cat) return; // unknown category: no pill
    var guide = GUIDES[cat];
    var designMode = root.hasAttribute('data-design-mode');
    var backend = (root.getAttribute('data-backend') || '').replace(/\/+$/, '');
    if (!designMode && !/^https:\/\//.test(backend)) return;
    // AB1: from here the pill would show for group A -> exposure ping (A and B), then group B stops: no pill, no dialog.
    if (!designMode) {
      abPing(backend, data.handle);
      var ab = abState();
      if (ab.on && ab.g === 'B') return;
    }

    var dialog = root.querySelector('[data-lu-dialog]');
    // Move the dialog to <body> so theme containers (sticky / overflow / transforms) cannot clip it.
    document.body.appendChild(dialog);
    root.__luDialog = dialog;
    var q = function (sel) { return dialog.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(dialog.querySelectorAll(sel)); };
    var consent = q('[data-lu-consent]');
    var consentHint = q('[data-lu-consent-hint]');
    var resultImg = q('[data-lu-result-img]');
    var previewImg = q('[data-lu-preview-src]');
    var cartErr = q('[data-lu-cart-error]');
    var busy = false;
    var objectUrls = [];
    var selectedVariant = String(data.selected || '');
    var sectionRoot = root.closest('.product-information--inner') || document;

    // ---- guide content. The example <img>s are built on the FIRST open, without loading="lazy": lazy images inside
    // a closed <dialog> that is later shown in the top layer can stay unloaded (empty grey frames, seen on a ring
    // page). Building them on open also keeps the ~150 KB of examples off the page load.
    q('[data-lu-lead]').textContent = guide.lead;
    q('[data-lu-tips]').innerHTML = guide.tips.map(function (t) { return '<li>' + t + '</li>'; }).join('');
    var examplesBuilt = false;
    function exUrl(k) { return abs(data.examples && data.examples[k]); }
    function buildExamples() {
      if (examplesBuilt) return;
      examplesBuilt = true;
      var da = exUrl(cat + '_da');
      function fig(yes, src, cap) {
        return '<figure class="lu-ex lu-ex--' + (yes ? 'yes' : 'no') + ' lu-ex--' + cat + '"><div class="lu-ex__frame">' +
          (src ? '<img src="' + src + '" alt="" decoding="async" width="480" height="600">' : '') + '</div>' +
          '<figcaption><b>' + (yes ? 'Așa da ✅' : 'Așa nu ❌') + '</b><span>' + cap + '</span></figcaption></figure>';
      }
      var html = fig(true, da, guide.yes);
      guide.nos.forEach(function (text, i) { html += fig(false, exUrl(cat + '_nu_' + (i + 1)), text); });
      q('[data-lu-examples]').innerHTML = html;
    }

    // The wrapper stays hidden: the gallery pill is the only entry point (no button under the buy box).

    function show(step) {
      qa('[data-lu-step]').forEach(function (s) { s.hidden = s.getAttribute('data-lu-step') !== step; });
      var inner = q('.lu-tryon-dialog__inner');
      if (inner) inner.scrollTop = 0;
    }
    function cleanupUrls() {
      objectUrls.forEach(function (u) { URL.revokeObjectURL(u); });
      objectUrls = [];
    }
    function showError(msg) {
      q('[data-lu-error-text]').textContent = msg;
      show('error');
    }

    function currentVariantId() {
      var input = sectionRoot.querySelector('product-form form input[name="id"]') || document.querySelector('product-form form input[name="id"]');
      return (input && input.value) || selectedVariant;
    }

    document.addEventListener('product:variant-change', function (e) {
      if (e.detail && e.detail.variant && e.detail.variant.id) selectedVariant = String(e.detail.variant.id);
    });

    function openDialog() {
      buildExamples();
      if (!busy) show('guide');
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      document.documentElement.classList.add('lu-tryon-lock');
    }
    function renderPill() {
      root.__luPill = addGalleryPill(root, openDialog, root.getAttribute('data-pill-label'), root.getAttribute('data-pill-pos'));
    }
    // AUTOHIDE1: no pill while the backend reports Google blocked (fail-open, see upstreamAvailable).
    if (designMode) renderPill(); else upstreamAvailable(backend, function (ok) { if (ok) renderPill(); });
    function close() {
      if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    }
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('lu-tryon-lock'); });
    q('[data-lu-close]').addEventListener('click', close);
    dialog.addEventListener('click', function (e) { if (e.target === dialog && !busy) close(); });

    consent.addEventListener('change', function () { if (consent.checked) consentHint.hidden = true; });
    qa('[data-lu-pick]').forEach(function (label) {
      if (designMode) label.classList.add('is-disabled');
      label.addEventListener('click', function (e) {
        if (designMode) { e.preventDefault(); return; }
        if (!consent.checked) {
          e.preventDefault();
          consentHint.hidden = false;
          consent.focus();
        }
      });
    });
    qa('[data-lu-file]').forEach(function (input) {
      input.addEventListener('change', function () {
        var f = input.files && input.files[0];
        input.value = '';
        if (f) run(f);
      });
    });
    qa('[data-lu-again]').forEach(function (b) { b.addEventListener('click', function () { cartErr.hidden = true; show('guide'); }); });

    q('[data-lu-cart]').addEventListener('click', function () {
      var btn = sectionRoot.querySelector('product-form button[name="add"]') || document.querySelector('product-form button[name="add"]');
      if (!btn || btn.disabled) {
        cartErr.textContent = 'Acest produs nu este disponibil momentan.';
        cartErr.hidden = false;
        return;
      }
      close();
      // Hidden line property _lu_tryon=da for this add only: the theme's ProductForm builds FormData(form)
      // synchronously in its submit handler, so the input is removed right after.
      var form = btn.form || (btn.closest && btn.closest('form'));
      var tag = null;
      try {
        if (form && !form.querySelector('input[name="properties[_lu_tryon]"]')) {
          tag = document.createElement('input');
          tag.type = 'hidden';
          tag.name = 'properties[_lu_tryon]';
          tag.value = 'da';
          form.appendChild(tag);
        }
      } catch (e) { tag = null; }
      try {
        btn.click(); // uses the theme's own add-to-cart (selected variant, cart drawer)
      } finally {
        if (tag) setTimeout(function () { if (tag.parentNode) tag.parentNode.removeChild(tag); }, 0);
      }
    });

    function run(file) {
      if (busy || designMode) return; // never call the backend from the theme editor
      if (!/^image\//.test(file.type || 'image/')) { showError(ERRORS.bad_photo); return; }
      busy = true;
      cleanupUrls();
      var vid = String(currentVariantId() || '');
      var pu = URL.createObjectURL(file);
      objectUrls.push(pu);
      previewImg.src = pu;
      show('loading');

      resizePhoto(file).then(function (blob) {
        if (blob.size > 8 * 1024 * 1024) throw { code: 'photo_too_big' };
        var fd = new FormData();
        fd.append('category', cat);
        // The backend reads the product images and dimensions itself from lu.ro/products/<handle>.js.
        fd.append('handle', data.handle || '');
        if (/^\d+$/.test(vid)) fd.append('variant_id', vid);
        fd.append('photo', blob, 'photo.jpg');
        var ctl = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = setTimeout(function () { if (ctl) ctl.abort(); }, CLIENT_TIMEOUT_MS);
        return fetch(backend + '/tryon', { method: 'POST', body: fd, signal: ctl ? ctl.signal : undefined, credentials: 'omit' })
          .then(function (r) {
            clearTimeout(timer);
            if (r.ok && /^image\//.test(r.headers.get('content-type') || '')) return r.blob();
            return r.json().catch(function () { return {}; }).then(function (j) { throw { code: j.error || 'generic', message: j.message }; });
          }, function (err) {
            clearTimeout(timer);
            throw { code: err && err.name === 'AbortError' ? 'timeout' : 'network' };
          });
      }).then(function (img) {
        var u = URL.createObjectURL(img);
        objectUrls.push(u);
        resultImg.src = u;
        cartErr.hidden = true;
        show('result');
        trackPreview(data.handle);
      }).catch(function (e) {
        var code = (e && e.code) || 'generic';
        showError(ERRORS[code] || (e && e.message) || ERRORS.generic);
      }).then(function () { busy = false; });
    }
  }

  // Small "Probează virtual" pill over the bottom-right corner of the main product image.
  // It lives in the gallery container (not in a slide), so it stays put while the mobile slider
  // is swiped; it is positioned over the first visible slide's box and re-measured on resize.
  function addGalleryPill(root, onClick, label, pos) {
    var detail = root.closest('.thb-product-detail') || document;
    var box = detail.querySelector('.product-image-container');
    var slider = box && box.querySelector('#Product-Slider, .product-images');
    if (!box || !slider || box.querySelector('[data-lu-pill]')) return null;
    var left = pos === 'left';
    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'lu-tryon-pill' + (left ? ' lu-tryon-pill--left' : '');
    pill.setAttribute('data-lu-pill', '');
    var span = document.createElement('span');
    span.textContent = label || 'Probează virtual ✨';
    pill.appendChild(span);
    pill.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); onClick(); });
    box.classList.add('lu-tryon-pill-host');
    box.appendChild(pill);

    function place() {
      if (!pill.isConnected) return;
      var slides = slider.querySelectorAll('.product-images__slide');
      var first = null;
      for (var i = 0; i < slides.length; i++) { if (slides[i].offsetWidth > 0) { first = slides[i]; break; } }
      var media = first && (first.querySelector('.product-single__media') || first);
      if (!media) { pill.hidden = true; return; }
      var b = box.getBoundingClientRect(), m = media.getBoundingClientRect();
      // undo the slider's horizontal scroll so the pill sits over the resting slide position
      var mLeft = m.left + (slider.scrollWidth > slider.clientWidth + 2 ? slider.scrollLeft : 0);
      var mRight = mLeft + m.width;
      if (left) {
        pill.style.left = Math.max(8, Math.round(mLeft - b.left + 12)) + 'px';
        pill.style.right = 'auto';
      } else {
        pill.style.right = Math.max(8, Math.round(b.right - mRight + 12)) + 'px';
      }
      pill.style.bottom = Math.max(8, Math.round(b.bottom - m.bottom + 12)) + 'px';
      pill.style.top = 'auto';
      pill.hidden = false;
    }
    place();
    window.addEventListener('resize', place);
    window.addEventListener('load', place);
    if (typeof ResizeObserver === 'function') new ResizeObserver(place).observe(box);
    // variant change can hide/show slides (theme option "hide variants")
    document.addEventListener('product:variant-change', function () { setTimeout(place, 300); });
    return pill;
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lu-tryon]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor: a re-rendered section brings a new [data-lu-tryon]; the old dialog (moved to <body>) and pill go.
  if (window.Shopify && Shopify.designMode && !window.__luTryonEditor) {
    window.__luTryonEditor = true;
    document.addEventListener('shopify:section:unload', function (e) {
      Array.prototype.forEach.call(e.target.querySelectorAll('[data-lu-tryon]'), function (root) {
        if (root.__luDialog) { try { root.__luDialog.close(); } catch (x) {} root.__luDialog.remove(); }
        if (root.__luPill) root.__luPill.remove();
        document.documentElement.classList.remove('lu-tryon-lock');
      });
    });
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  }
})();
